<template>
  <div>
    <b-row>
      <b-col lg="8">
        <h2><a href="#" @click="goback"> Product scenarios </a> > {{form.scenarioName ? form.scenarioName: 'new'}}</h2>
      </b-col>
      <b-col class="text-right">
        <b-button variant="dark" :disabled="ready" squared style="width:150px;argin-bottom: 0.5rem;" @click="register">
          제품시나리오생성</b-button>
      </b-col>
    </b-row>
    <p></p>
    <b-card>
      <b-card-group deck>
        <b-card style="cursor:pointer;max-width: 20rem;" border-variant="primary" v-for="card, i of cardDatas" :key="i">
          <b-card-title class="text-center">{{card.title}}</b-card-title>
          <b-card-sub-title class="text-center"> {{card.subtitle ? card.subtitle: '&nbsp;'}}</b-card-sub-title>
          <b-card-img height="120" width="120" :src="card.image" alt="Center image">
          </b-card-img>
          {{card.text}}
        </b-card>
      </b-card-group>
    </b-card>
    <p></p>
    <h4>Scenario details</h4>
    <b-row>
      <b-col lg="6">
        <b-form-group id="input-group-ScenarioName" label="Scenario name:" label-for="_ScenarioName"
          description="시나리오에 사용될 이름입니다.">
          <b-form-input id="_ScenarioName" v-model="form.scenarioName" type="text">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <b-form-group id="input-group-ScenarioDesc" label="Description (optional)" label-for="ScenarioDesc"
          description="공급망 흐름을 설명하도록 작성해주세요.">
          <b-form-textarea id="ScenarioDesc" v-model="form.scenarioDesc" placeholder="공급망 흐름을 설명하세요" rows="15"
            max-rows="20">
          </b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <p></p>
  </div>

</template>
<script>

import hal from 'hateoas-hal-link-resolver'
export default {
  components: {
  },
  created() {
  },
  mounted() {
  },
  async beforeMount() {
    this.organization = await this.$getOrganization();
    this.form.organization = hal(await this.$getOrganization(), 'self');
  },
  data() {
    return {
      ready: true,
      organization: null,
      form: {
        scenarioName: null,
        organization: null,
        scenarioDesc: null,
      },
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async register() {
      // console.log(this.organization)
      const profile = await this.$profile();
      const url = hal(profile, 'scenarios');
      try {
        const response = await this.$http.post(url, this.form);
        this.$router.push({ path: '/scenario/build/details', query: response.data._links.self});
      }catch(err){
        alert(err)
      }
    },
    state() {
      this.ready = this.form.scenarioName ? false : true;
    }
  },
  computed: {
    cardDatas() {
      const data = [
        {
          title: 'Scenario details',
          subtitle: '',
          image: 'img/bg/avatar_facility_rev_02.svg',
          text: '시나리오 이름, 시나리오 설명과 같은 기본 정보'
        },
        {
          title: 'List of products',
          subtitle: 'Optional',
          image: 'img/bg/avatar_list_of_products.svg',
          text: '완제품에서 반제품, 원자재에 이르기까지 이 시나리오에 포함될 제품에 대해 생각해 보세요. 이것은 단지 당신이 그것을 만드는 동안 시나리오에 집중하도록 하기 위한 것입니다.'
        },
        {
          title: 'List of facilities',
          subtitle: 'Optional',
          image: 'img/bg/avatar_scenario_details.svg',
          text: '이 목록은 제품이 배송, 처리, 포장 또는 기타 활동과 함께 통과하는 시설의 샘플을 수집합니다. 다시 말하지만, 이 목록은 시나리오 구축에 집중할 수 있도록 선택 사항입니다.'
        }
      ]
      return data;
    }
  },
  watch: {
    'form.scenarioName': function () {
      this.state()
    }
  }
}
</script>
